/**
 * Battery - A missile battery that launches counter-missiles
 * Has ammo count and position. Refills each wave.
 */

export class Battery {
  constructor(x, y) {
    this.x = x;
    this.y = y;
    this.ammo = 10;
    this.maxAmmo = 10;
    this.alive = true;
  }

  /**
   * Fire a missile, decrementing ammo.
   * @returns {boolean} true if fired, false if empty.
   */
  fire() {
    if (this.ammo > 0 && this.alive) {
      this.ammo--;
      return true;
    }
    return false;
  }

  /**
   * Refill ammo to max (called at start of each wave).
   */
  refill() {
    this.ammo = this.maxAmmo;
    this.alive = true;
  }

  render(ctx, gameWidth, gameHeight) {
    if (!this.alive) {
      this._renderDestroyed(ctx);
      return;
    }

    ctx.save();

    // Battery platform/base - wider trapezoidal base
    ctx.fillStyle = '#223366';
    ctx.beginPath();
    ctx.moveTo(this.x - 20, this.y);
    ctx.lineTo(this.x - 12, this.y - 6);
    ctx.lineTo(this.x + 12, this.y - 6);
    ctx.lineTo(this.x + 20, this.y);
    ctx.closePath();
    ctx.fill();

    // Battery turret - glowing blue launcher
    ctx.fillStyle = '#4488ff';
    ctx.shadowColor = '#0088ff';
    ctx.shadowBlur = 10;
    ctx.beginPath();
    ctx.moveTo(this.x - 10, this.y - 6);
    ctx.lineTo(this.x - 5, this.y - 18);
    ctx.lineTo(this.x + 5, this.y - 18);
    ctx.lineTo(this.x + 10, this.y - 6);
    ctx.closePath();
    ctx.fill();

    // Launcher nozzle
    ctx.fillStyle = '#66aaff';
    ctx.shadowBlur = 5;
    ctx.fillRect(this.x - 3, this.y - 22, 6, 5);

    // Ammo display - responsive font size based on screen width
    ctx.shadowBlur = 0;
    const ammoColor = this.ammo > 3 ? '#00ffff' : this.ammo > 0 ? '#ffaa00' : '#ff3333';
    ctx.fillStyle = ammoColor;
    ctx.shadowColor = ammoColor;
    ctx.shadowBlur = 4;
    const ammoFontSize = (gameWidth && gameWidth < 800) ? 10 : 12;
    ctx.font = `${ammoFontSize}px "Share Tech Mono", monospace`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(`${this.ammo}`, this.x, this.y + 3);

    // Ammo pips - small dots showing individual missiles
    ctx.shadowBlur = 0;
    const pipSpacing = (gameWidth && gameWidth < 800) ? 2.5 : 3;
    const totalWidth = (this.maxAmmo - 1) * pipSpacing;
    const startX = this.x - totalWidth / 2;
    const pipY = (gameWidth && gameWidth < 800) ? this.y + 14 : this.y + 18;
    const pipRadius = (gameWidth && gameWidth < 800) ? 0.8 : 1;
    for (let i = 0; i < this.maxAmmo; i++) {
      ctx.fillStyle = i < this.ammo ? '#00ffff' : '#333355';
      ctx.beginPath();
      ctx.arc(startX + i * pipSpacing, pipY, pipRadius, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.restore();
  }

  _renderDestroyed(ctx) {
    ctx.save();
    // Destroyed battery - rubble
    ctx.fillStyle = '#334466';
    ctx.fillRect(this.x - 12, this.y - 3, 24, 3);
    ctx.fillStyle = '#223344';
    ctx.fillRect(this.x - 8, this.y - 5, 6, 5);
    ctx.fillRect(this.x + 2, this.y - 4, 5, 4);
    ctx.restore();
  }
}
